import React from 'react';
import clsx from 'clsx';

import { ReactComponent as ArrowUpRight } from '@/assets/icons/arrow_up_right.svg';
import { ReactComponent as ArrowDownRight } from '@/assets/icons/arrow_down_right.svg';
import { useTokenPrices } from '@/common/providers/TokenPriceProvider/hooks.ts';

import styles from './component.module.scss';

export const CurrencyTicker = ({
  coinId
}: {
  coinId: keyof ReturnType<typeof useTokenPrices>;
}) => {
  const priceList = useTokenPrices();

  const coinPrice = priceList[coinId];

  if (!coinPrice) {
    return null;
  }

  return (
    <>
      <span className={clsx(styles.coin, styles.coinName)}>
        {coinId.toLocaleUpperCase()}{' '}
        {typeof coinPrice.usd === 'number'
          ? `$${coinPrice.usd.toLocaleString('en-US', {
              maximumFractionDigits: 3,
              minimumFractionDigits: 2
            })}`
          : 'N/A'}
      </span>
      {coinPrice.usd_24h_change && (
        <span
          className={clsx(
            styles.coin,
            styles.diff,
            typeof coinPrice.usd_24h_change === 'number' &&
              coinPrice.usd_24h_change > 0
              ? styles.coinIncrease
              : styles.coinDecrease
          )}
        >
          {coinPrice.usd_24h_change.toLocaleString('en-US', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0
          })}
          %
          {coinPrice.usd_24h_change > 0 ? <ArrowUpRight /> : <ArrowDownRight />}
        </span>
      )}
    </>
  );
};
